import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Components
import CurrentSeasonInProgressGate from '../../../../components/CurrentSeasonInProgressGate';

interface Props {
    updateQueryString: Function;
}

export class CreateSeasonalEventButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.updateQueryString({
            seasonalEventModal: 'edit',
            selectedEvent: undefined
        });
    };

    render() {
        return (
            <CurrentSeasonInProgressGate>
                <Button
                    circular
                    secondary
                    size="small"
                    className="black float"
                    onClick={this.handleClick}
                >
                    Schedule Pick
                </Button>
            </CurrentSeasonInProgressGate>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(CreateSeasonalEventButton);
